/* Science page — per-section citation numbering. Ported verbatim from the full-site handoff
   pages/science/Science.html. Each section with [data-notes] numbers its own sources 1..n in
   order of first appearance and lists them in its .sc-notes block, sourced from #references. */
(function () {
  var refs = {};
  document.querySelectorAll('#references li[id^="ref-"]').forEach(function (li) { refs[li.id] = li.dataset.short || li.innerHTML; });
  document.querySelectorAll('[data-notes]').forEach(function (sect) {
    var order = [], map = {};
    sect.querySelectorAll('.cite[data-src]').forEach(function (c) {
      var nums = c.dataset.src.trim().split(/\s+/).map(function (k) {
        if (!(k in map)) { order.push(k); map[k] = order.length; }
        return map[k];
      });
      nums.sort(function (a, b) { return a - b; });
      c.innerHTML = nums.map(function (num, i) {
        return '<a href="#' + sect.id + '-note-' + num + '">' + (i ? ',' + num : num) + '</a>';
      }).join('');
    });
    var host = sect.querySelector('.sc-notes');
    if (!host) return;
    if (!order.length) { host.remove(); return; }
    host.innerHTML = '<p class="sc-notes-lab">References</p>' + order.map(function (k, i) {
      return '<span class="cite-row" id="' + sect.id + '-note-' + (i + 1) + '">' +
        '<span class="fn-mark">' + (i + 1) + '</span>' +
        '<span class="cite-body">' + (refs[k] || '') + '</span></span>';
    }).join('');
  });
})();
